import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { SocialProvider } from './context/socialProvider.tsx';

if (import.meta.env.VITE_SENTRY_ENABLED) {
  import("./vendors/sentry");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <BrowserRouter>
    <SocialProvider>
      <App />
    </SocialProvider>
  </BrowserRouter>
  // </React.StrictMode>,
);
